
import Vue from "vue";
import Component from "vue-class-component";
import TruckTemplateModule from "@/store/modules/truckTemplate";
import { getModule } from "vuex-module-decorators";
import { CreateTruckTemplateRequest } from "../../models/api/truckTemplate/createTruckTemplates";
import Select from "../../components/form/Select.vue";
import { TruckTemplate } from "@/models/api/truckTemplate/getTruckTemplates";
import { UpdateTruckTemplateRequest } from "@/models/api/truckTemplate/updateTruckTemplates";
import notifications from "../../lib/notifications";

const truckTemplateModuleState = getModule(TruckTemplateModule);

@Component({
  components: {
    Select
  }
})
export default class NewTruckTemplate extends Vue {
  newTruckTemplate: AddTruckTemplateViewModel = {
    truckTemplateName: "",
    tripDays: 0,
    maxCubes: 0,
    zipsServed: [],
    weekDays: [],
    facilityCode: "",
    id: null
  };
  saving: boolean = false;
  async created() {
    if (this.$route.params.id) {
      let result: TruckTemplate = await truckTemplateModuleState.getTruckTemplate(
        +this.$route.params.id
      );

      this.newTruckTemplate = {
        ...result,
        truckTemplateName: result.name,
        zipsServed: result.truckTemplateZip3.map(zip => zip.zip3),
        weekDays: result.truckTemplateWeekdays.map(WeekDay => WeekDay.weekDay)
      };
    }
  }

  get weekDays() {
    return truckTemplateModuleState.weekdays;
  }

  resetModal() {}

  async submit() {
    this.saving = true;
    let hasErrors: boolean = false;

    try {
      if (!this.newTruckTemplate.id) {
        const truckTemplateRequest: CreateTruckTemplateRequest = {
          truckTemplateName: this.newTruckTemplate.truckTemplateName,
          tripDays: this.newTruckTemplate.tripDays,
          maxCubes: this.newTruckTemplate.maxCubes,
          truckTemplateZip3s: this.newTruckTemplate.zipsServed.map(zip => ({ Zip3: zip })),
          truckTemplateWeekdays: this.newTruckTemplate.weekDays.map(WeekDay => ({ WeekDay })),
          facilityCode: this.newTruckTemplate.facilityCode
        };
        const response = await truckTemplateModuleState.createTruckTemplate(truckTemplateRequest);
      } else {
        const truckTemplateRequest: UpdateTruckTemplateRequest = {
          id: this.newTruckTemplate.id,
          truckTemplateName: this.newTruckTemplate.truckTemplateName,
          tripDays: +this.newTruckTemplate.tripDays,
          maxCubes: +this.newTruckTemplate.maxCubes,
          truckTemplateZip3s: this.newTruckTemplate.zipsServed.map(zip => ({ Zip3: zip })),
          truckTemplateWeekdays: this.newTruckTemplate.weekDays.map(WeekDay => ({ WeekDay })),
          facilityCode: this.newTruckTemplate.facilityCode
        };
        const response = await truckTemplateModuleState.updateTruckTemplate(truckTemplateRequest);
      }
    } catch (ex) {
      hasErrors = true;
      notifications.error("Truck Template Saved", "Failed to save truck template", ex);

    }

    this.saving = false;

    if (!hasErrors) {
      notifications.success("Truck Template Saved", "Successfully saved truck template");
      this.$router.push({ path: "/admin/truckTemplate" });
    }
  }
}

interface AddTruckTemplateViewModel {
  id: number;
  truckTemplateName?: string;
  zipsServed?: string[];
  weekDays?: string[];
  maxCubes?: number;
  tripDays?: number;
  facilityCode?: string;
}
